export default __webpack_public_path__ + "static/media/drag-handle.9f1c29ab.svg";